/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'briefcase': {
    width: 19,
    height: 18,
    viewBox: '0 0 19 18',
    data: '<path pid="0" d="M18.545 9.818v6.546c0 .903-.732 1.636-1.636 1.636H1.636A1.636 1.636 0 010 16.364V9.818h6.545v3.273H12V9.818h6.545zm-8.181 0v1.637H8.182V9.818h2.182zM12.545 0c.904 0 1.637.733 1.637 1.636V6h1.09V3.818h1.637a1.636 1.636 0 011.636 1.637v2.727H0V5.455c0-.904.733-1.637 1.636-1.637h1.637V6h1.09V1.636C4.364.733 5.097 0 6 0h6.545zm0 1.636H6v2.182h6.545V1.636z" _fill="#EC102D" fill-rule="nonzero"/>'
  }
})
